"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.ShoppingToolsCard = void 0;
var _shoppingToolsCard = _interopRequireDefault(require("./components/shopping-tools-card"));
exports.ShoppingToolsCard = _shoppingToolsCard["default"];